/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import SizePicker from './SizePicker'
import AbandonIncompatibleExactSizeCallout from './AbandonIncompatibleExactSizeCallout'

import type { Props as SizePickerProps } from './types'

const SizePickerRouter: React.FunctionComponent<SizePickerProps> = (props) => {
  const { hasIncompatibleSize } = props

  if (hasIncompatibleSize) {
    return <AbandonIncompatibleExactSizeCallout {...props} />
  }

  return <SizePicker {...props} />
}

export default SizePickerRouter
